
import Vue from "vue";
import SubHeader from "@/views/layout/header/SubHeader.vue";
import Search from "@/components/Search.vue";
import { Component } from "vue-property-decorator";
import MenuFooter from "@/views/layout/footer/MenuFooter.vue";
import api from "@/api";
import TicketModel from "@/models/createTicket/TicketModel";
import TextFloating from "@/components/input/TextFloating.vue";
import FileInput from "@/components/input/FileInput.vue";
import LoadingOverlay from "@/components/overlay/LoadingOverlay.vue";

import { ValidationObserver, ValidationProvider } from "vee-validate";
import utils from "@/utils";
import AttachmentModel from "@/models/createTicket/AttachmentModel";
import WorkorderModel from "@/models/createTicket/WorkorderModel";
import FeedbackModel from "@/models/createTicket/FeedbackModel";
@Component({
    components: {
        SubHeader,
        Search,
        MenuFooter,
        FileInput,
        LoadingOverlay,

        ValidationObserver,
        ValidationProvider,
        TextFloating,
    },
})
export default class ListNotification extends Vue {
    mounted() {
        this.getDetailTicket(this.$route.params.woid);
        this.feedback.work_orders_id = Number(this.$route.params.woid);
        this.getDetailFeedback(this.$route.params.id);
    }
    utils = utils;

    step = 0;

    listImage: AttachmentModel[] = [];
    
    theprocess : boolean = false;

    isActiveDuration1: boolean = false;
    isActiveDuration2: boolean = false;
    isActiveDuration3: boolean = false;
    isActiveDuration4: boolean = false;
    isActiveDuration5: boolean = false;
    isActiveDuration6: boolean = false;
    isActiveDesc: boolean = false;
    isActiveClock: boolean = false;
    isActiveSubject: boolean = false;

    isBreakdown(yes = true) {
        // return true;
        if(yes){
            return this.ticket?.activitymaintenance?.name == 'Breakdown'
        }else{
            return this.ticket?.activitymaintenance?.name != 'Breakdown'
        }
    }

    cekDur1() {
        if (this.feedback.duration_time_min != null) {
            this.isActiveDuration1 = true;
        } else {
            this.isActiveDuration1 = false;
        }
    }
    cekDur2() {
        if (this.feedback.production_shift_on_downtime_min != null) {
            this.isActiveDuration2 = true;
        } else {
            this.isActiveDuration2 = false;
        }
    }
    cekDur3() {
        if (this.feedback.time_to_repair != null) {
            this.isActiveDuration3 = true;
        } else {
            this.isActiveDuration3 = false;
        }
    }
    cekDur4() {
        if (this.feedback.time_to_action != null) {
            this.isActiveDuration4 = true;
        } else {
            this.isActiveDuration4 = false;
        }
    }
    cekDur5() {
        if (this.feedback.time_between_failure != null) {
            this.isActiveDuration5 = true;
        } else {
            this.isActiveDuration5 = false;
        }
    }
    cekDur6() {
        if (this.feedback.time_total_stopage != null) {
            this.isActiveDuration6 = true;
        } else {
            this.isActiveDuration6 = false;
        }
    }
    cekClock() {
        if (this.feedback.date_issue != null) {
            this.isActiveClock = true;
        } else {
            this.isActiveClock = false;
        }
    }

    cekDesc() {
        if (this.feedback.report_explanation != null) {
            this.isActiveDesc = true;
        } else {
            this.isActiveDesc = false;
        }
    }
    cekSubject() {
        if (this.feedback.subject != null) {
            this.isActiveSubject = true;
        } else {
            this.isActiveSubject = false;
        }
    }

    material_usage: any = [];

    feedback: FeedbackModel = new FeedbackModel();
    ticket: WorkorderModel = new WorkorderModel();

    getDetailTicket(idTicket: string) {
        return new Promise((resolve, reject) => {
            api.ticket
                .getDetailTask2(idTicket)
                .then((response) => {
                    if (response.data.code === 200) {
                        this.ticket = Object.assign({}, response.data.data);
                        resolve(response);
                    }
                })
                .catch((err: any) => {
                    reject(err);
                    this.$swal("Error", err?.response?.data?.message, "error");
                });
        });
    }

    getDetailFeedback(idTicket: string) {
        return new Promise((resolve, reject) => {
            api.ticket
                .getFeedback(idTicket)
                .then((response) => {
                    if (response.data.code === 200) {
                        this.feedback = Object.assign({}, response.data.data);
                        this.feedback.date_issue = this.feedback.date_issued_at ? new Date(this.feedback.date_issued_at) : null;
                        this.feedback.materials = this.feedback.materials.map((item: any) => {
                            return {
                                qty_actual: item.actual_qty,
                                qty: item.planed_qty,
                                ...item,
                            }
                        })
                        resolve(response);
                    }
                })
                .catch((err: any) => {
                    reject(err);
                    this.$swal("Error", err?.response?.data?.message, "error");
                });
        });
    }
    saveFeedback() {

        // if (this.ticket.materials.length > 0 && this.step == 0) {
        //     this.step++;
        // } else {
        //     if(this.theprocess) return
            this.theprocess = true;
            const data = this.feedback;
            data.feedback_id = Number(this.$route.params.id);
            api.ticket.updateFeedback(data).then((response) => {
                if (response.data.code == 200) {
                    this.$router.back();
                } else {
                    this.theprocess = false;
                    this.$swal("Peringatan", response.data.message, "warning");
                }
            });
        // }
    }

    goBack() {
        this.$router.back();
    }
    nextPage() {
        this.$router.push(`/ticket-feedback-view/${this.$route.params.id}`);
    }

    addUploadImgRow() {
        const image = { path: null, label: null };
        this.feedback.attachment.push(image);
    }
    removeUploadRow(i: number) {
        this.feedback.attachment.splice(i, 1);
    }
    get colorStatus() {
        if (this.ticket.status === "new") {
            return "cl-red";
        } else {
            return "cl-green-light";
        }
    }
    get pitaStatus() {
        if (this.ticket.status === "new") {
            return "new";
        } else {
            return "on-progress";
        }
    }
}
